<template>
 <main>
  <p>My name is Michael Largent. I am a full stack software engineer, who is extremely proficent in Javascript (vanilla/vuejs/nodejs). I'm experienced in UI/UX design in Sketch, web scrapers, api integrations, coding responsive websites, and financial pattern recognition.<p>
  <p>I’ve been coding since 2008, but only professionally since 2011. I’ve built 5 websites, a private Roku app, a video compression/distribution cluster, automated trading routines, and a social online marketplace (this one never made it to launch).</p>
  <p>This site has always been intended to be my personal portfolio and journal entries, but with work, the projects I’m involved in, and code I maintain, my time that I can allocate to this will be limited. This build will be depolyed incrementally with no etas.</p>
 </main>
</template>
<script>
import updateAvatarTitle from '@/lib/updateAvatarTitle';
export default {
 mounted(){
  updateAvatarTitle('Welcome',this);
 }
}
</script>
